import FormattingTooltip from '@/components/basicComponents/tooltip/dollarsTooltip';
import { MobileRow, MobileRowTitle, MobileRowValue, MobileTableRowWrap } from '@/components/table/mobileTable/mobileTable';
import { themeVar } from '@/styles/theme';
import styled from 'styled-components';
import { allEntitiesSummaryTableColumns } from '../../../constants';
import { InvestorDetailsSummaryTabHouseholdSummaryQuery } from '@/__generated__/graphql';

interface AllEntitiesSummaryMobileTableSumFooterProps {
  tableTotalRowData: InvestorDetailsSummaryTabHouseholdSummaryQuery['investorHouseholdSummary']['totals'] | null;
  showSpecificColumns: boolean;
}

const AllEntitiesSummaryMobileTableSumFooter = ({ tableTotalRowData, showSpecificColumns }: AllEntitiesSummaryMobileTableSumFooterProps) => {
  if (!tableTotalRowData) return <></>;

  return (
    <MobileSumFooterWrap>
      <MobileRow>
        <MobileRowTitle>Total</MobileRowTitle>
      </MobileRow>

      {showSpecificColumns && (
        <MobileRow>
          <MobileRowTitle>{allEntitiesSummaryTableColumns[1].title}</MobileRowTitle>
          <MobileRowValue>
            <FormattingTooltip>{tableTotalRowData.entityValueTotal}</FormattingTooltip>
          </MobileRowValue>
        </MobileRow>
      )}

      <MobileRow>
        <MobileRowTitle>{allEntitiesSummaryTableColumns[3].title}</MobileRowTitle>
        <MobileRowValue>
          <FormattingTooltip>{tableTotalRowData.currentNAVTotal}</FormattingTooltip>
        </MobileRowValue>
      </MobileRow>

      <MobileRow>
        <MobileRowTitle>{allEntitiesSummaryTableColumns[4].title}</MobileRowTitle>
        <MobileRowValue>
          <FormattingTooltip>{tableTotalRowData.unfundedCommitmentTotal}</FormattingTooltip>
        </MobileRowValue>
      </MobileRow>

      {showSpecificColumns && (
        <MobileRow>
          <MobileRowTitle>{allEntitiesSummaryTableColumns[5].title}</MobileRowTitle>
          <MobileRowValue>
            <FormattingTooltip>{tableTotalRowData.capacityTotal}</FormattingTooltip>
          </MobileRowValue>
        </MobileRow>
      )}
    </MobileSumFooterWrap>
  );
};

export default AllEntitiesSummaryMobileTableSumFooter;

const MobileSumFooterWrap = styled(MobileTableRowWrap)`
  background-color: ${themeVar('layer.2')};
`;
